import Utils from '../../utils/Utils';
import CounterValidEmailTask from '../../requests/tasks/user/CounterValidEmailTask';
import ModifyUserTask from '../../requests/tasks/user/ModifyUserTask';
import RequestManager from "../../requests/RequestManager";

class UtilsIpTelmex {

    static async validateMail(userhash) {

        //Harcode para oblgar a mostrar el cambio de correo
        /*
        return new Promise((resolve, reject) => {
            resolve({
                        validEmail : false,
                        userDetectWS: {}
                    });
        });
        */

        const task = new CounterValidEmailTask({ userhash: userhash });
        const result = await RequestManager.addRequest(task);
        const user_mail_validation = Utils.getApaMetadataKey('user_mail_validation', '{"enable":false,"limit":3}')

        try {

            if ((user_mail_validation.enable === false) || userhash === '' ) {
                return new Promise((resolve, reject) => {
                    resolve({
                        validEmail : true,
                        userDetectWS: {}
                    });
                });
            }

            if (result.response) {

                const limit =  user_mail_validation.limit ? user_mail_validation.limit : 0;

                if (result.response.counterValidEmail <= limit) {
                    return new Promise((resolve, reject) => {
                        resolve({
                            validEmail: true,
                            userDetectWS: {}
                        });
                    });
                } else
                {
                    return new Promise((resolve, reject) => {
                        resolve(result.response)
                    });
                }

            }
        } catch (err) {
            return new Promise((resolve, reject) => {
                resolve({
                    validEmail: true,
                    userDetectWS: {}
                });
            });
        }
    }

    static async userModifyMail(email, user_hash) {
        const task = new ModifyUserTask({ email: email, user_hash: user_hash});
        const result = await RequestManager.addRequest(task);
        return new Promise((resolve, reject) => {
            resolve(result.response);
        });
    }
}

export default UtilsIpTelmex;


// WEBPACK FOOTER //
// ./src/utils/user/IpTelmex.js